import { motion } from 'framer-motion'
import styled, { css } from 'styled-components/macro'
import { styleReset } from 'styles/misc'
import { mq } from 'styles/mq'
import { theme } from 'styles/theme'

export const ShareContent = styled.div<{ $isShare?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: end;
  width: 100%;
  padding-inline: var(--container-spacing);

  ${props =>
    props.$isShare &&
    css`
      position: absolute;
      right: 0;
      height: var(--header-height);
    `}

  ${mq.medium} {
    display: contents;
  }
`

export const ShareContainer = styled(motion.div)<{
  $spacing: 'small' | 'large'
  $isShare?: boolean
}>`
  display: flex;
  justify-content: center;
  overflow: hidden;
  gap: ${props => (props.$spacing === 'small' ? '0.7rem' : '1.5rem')};

  ${props =>
    props.$isShare &&
    css`
      &::before,
      &::after {
        content: '';
        display: block;
        padding-right: 1rem;
      }
    `}
`

export const Button = styled(motion.a)`
  display: block;
  font-size: 3.2rem;
  color: inherit;
  border: 2px solid currentColor;
  border-radius: 50%;

  svg {
    display: block;
  }

  &:hover,
  &:focus-visible {
    color: white;
    border-color: transparent;
    background-color: ${theme.colors.accent.primary};
  }
`

export const ShareToggle = styled.button`
  ${styleReset}
  font-size: 2rem;
  cursor: pointer;

  ${mq.medium} {
    display: none;
  }

  &:hover,
  &:focus-visible {
    color: ${theme.colors.accent.primary};
  }

  svg {
    display: block;
  }
`
